'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _Logs = require('../../helpers/Logs');

var _Login = require('../../helpers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Provider = require('../../helpers/Provider');

var _Router = require('../../helpers/Router');

var _SessionStorage = require('../../helpers/SessionStorage');

var _auth = require('../../redux/modules/auth');

var _AuthorizationMobile = require('./AuthorizationMobile.scss');

var _AuthorizationMobile2 = _interopRequireDefault(_AuthorizationMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileIcon = require('../../../res/images/icon/mobile.svg');

var AuthorizationMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth, appInfo: state.appInfo, log: state.log };
}, { mobileGetUser: _auth.mobileGetUser, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AuthorizationMobile, _Component);

  function AuthorizationMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AuthorizationMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AuthorizationMobile.__proto__ || (0, _getPrototypeOf2.default)(AuthorizationMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: false,
      provider: null
    }, _this.onOk = function () {
      _this.setState({ loading: true });
      _this.props.mobileGetUser();
    }, _this.onCancel = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.Authorization));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AuthorizationMobile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var provider = (0, _Provider.getProviderFromStorage)(_SessionStorage.SessionStorageKeys.SelectedProviderKey);
      this.setState({ provider: provider });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.loading && !nextProps.auth.loading) {
        if (!nextProps.auth.error && (0, _Login.isUserAuthorize)(nextProps.auth.userInfo)) {
          (0, _Login2.default)(nextProps.auth.sessionId, nextProps.auth, this.props.log, this.props.appInfo, this.props.pushState);
        } else {
          this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.AuthorizationError));
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var providerName = this.state.provider ? this.state.provider.name : '';
      return _react2.default.createElement(
        'div',
        { className: _AuthorizationMobile2.default.authorizationMobile },
        _react2.default.createElement(
          'div',
          { className: _AuthorizationMobile2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Authorization)
        ),
        _react2.default.createElement(_components.ProviderLogo, { className: _AuthorizationMobile2.default.providerLogo, provider: this.state.provider }),
        _react2.default.createElement(
          'div',
          { className: _AuthorizationMobile2.default.mobile },
          _react2.default.createElement('img', { src: mobileIcon })
        ),
        _react2.default.createElement(
          'div',
          { className: _AuthorizationMobile2.default.message },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.AuthorizationMobileMessage)
        ),
        _react2.default.createElement(_components.BaseButton, { className: _AuthorizationMobile2.default.button, onClick: function onClick() {
            return _this2.onOk();
          }, buttonString: _DefaultString.translations.Ok, loading: this.state.loading }),
        _react2.default.createElement(_components.BaseButton, { className: _AuthorizationMobile2.default.button, onClick: function onClick() {
            return _this2.onCancel();
          }, buttonString: _DefaultString.translations.Cancel }),
        _react2.default.createElement(_components.HintPopup, {
          className: _AuthorizationMobile2.default.whyAuthorize,
          text: _DefaultString.translations.WhyAuthorize,
          hintText: _DefaultString.translations.WhyAuthorizeReason,
          hintTextValue: providerName,
          navigationLog: _Logs.LogName.WhyAuthorize
        })
      );
    }
  }]);
  return AuthorizationMobile;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  appInfo: _react.PropTypes.object,
  mobileGetUser: _react.PropTypes.func.isRequired,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(AuthorizationMobile);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthorizationMobile/AuthorizationMobile.js
// module id = 1997
// module chunks = 0